import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import $ from 'jquery';
        import 'react-datepicker/dist/react-datepicker.css';
        import CryptoJS from 'crypto-js';
        import config from 'react-global-configuration';
class EditTicket extends Component {
    constructor(){
        super();
                var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
                var localdata = has_local_data?this.decrypt(localStorage.getItem('encdata'), 0):'';
                this.state = {
            message:'',
            apiUrl:this.decryptconfigdata('apiUrl'),
            owners:[],
            app:[],
            studio:[],
            account_manager:[],
            title:'',
            description:'',
            helpdesk_id:'',
            type:'',
            appname:'',
            priorty:'Medium',
            //studio_email:'',
            eta:'',
            status:'Open',
            assigned_to:'',
            escalation_level:'L1',
            ticket_email_cc:'',
            account_managerinse:'',
            project:'',
            ticket:'',
                        userId:has_local_data?localdata.user_id:'',
                        userName:has_local_data?localdata.user_name:'',
                        userAuthKey:has_local_data?localdata.user_key:'',
            fields: {},
            errors: {},
           // startDate:moment(),
            loading:1,
            checkBox: true,
            setdefault: '',
            imageDet:'',
            accountManagerId: null
           }
        this.updateTicket = this.updateTicket.bind(this);
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.onChange = this.onChange.bind(this);
        this.tick = this.tick.bind(this);
    }
        decryptconfigdata(configkey){
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
                var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
                var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
                iv
                });
                var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                return plaintext;
        }

        decrypt(findresponse, flg){
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
                var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
                var res = flg ? findresponse.encdata : findresponse;
                var bytes = CryptoJS.AES.decrypt(res, key, {
                iv
                });
                var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                return JSON.parse(plaintext);
        }
              rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    handleValidation(){
        let fields = this.state.ticket;
        let errors = {};
        let formIsValid = true;
        console.log(this.state.ticket);
        //Name
                if (!fields["title"]){
           formIsValid = false;
           errors["title"] = "This field is required.";
        }
        if (!fields["description"]){
            formIsValid = false;
            errors["description"] = "This field is required.";
        }
        if (fields["dev_hours"] && !this.isValidNumber(fields["dev_hours"])){
            formIsValid = false;
            errors["dev_hours"] = "Please Provide Numbers Only.";
        }
   
       this.setState({errors: errors});
       return formIsValid;
   }

     back(id){
        window.location.href = '/viewTicket/' + id;
    }
    
      updateTicket(){
        if (this.handleValidation()){
            console.log("Data Has been submitted");
            //return false;
        } else{
            console.log("This Fields Are required.")
            return false;
         }
        document.getElementById("update_ticket").innerHTML = "Sending....";
         let img = document.getElementById('fileInput').files.length;
         const fd = new FormData;
                if (img > 0){
            for (var x = 0; x < img; x++) {
                 fd.append("image[]", document.getElementById('fileInput').files[x]);
             }
            }
        document.getElementById("update_ticket").disabled = true;
        fd.append('ticket_inputs', JSON.stringify(this.state));
                fetch(this.state.apiUrl + '/TicketRest/UpdateTicket/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
                .then((Response) => Response.json())
                .then((findresponse) =>
        {
                
                findresponse = this.rawjsonparse(findresponse, 1);
                        if (findresponse.code == 200){
                    this.setState({ message: findresponse.msg }, function() {
                    this.props.history.push('/ticket/viewTicket/id/'+this.state.ticket.id);
                     }); 
                } else {
                    this.setState({message:findresponse.msg});
                    document.getElementById("add_ticket").innerHTML = "Update Ticket";
                    document.getElementById("update_ticket").disabled = false;
                }
              
        }) 
    }
   
        onChange(propertyName, event){
        const ticket = this.state.ticket;
        ticket[propertyName] = event.target.value;
        this.setState({ ticket: ticket });
      }
    
      handleChangeDate(date) {
        this.setState({
          startDate: date,
          etaDate:moment(date).format("YYYY-MM-D")
        }, function(){
            console.log(this.state.etaDate);
        });
      }
          
      handleCheck(event){
        this.setState({[event.target.name]: event.target.value});
        //console.log(this.state);
      }
      ticketsList() {
        fetch(this.state.apiUrl + '/TicketRest/Adddetails/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
                .then((Response) => Response.json())
                .then((findresponse) =>
                {
                findresponse = this.rawjsonparse(findresponse, 1);
                    this.setState({
                        loading:0,
                        app: findresponse.app,
                        owners: findresponse.owner,
                       studio: findresponse.studio,
                       account_manager: findresponse.account_manager
                 
                    })
                })
    }
    getTicketDetails(){
        fetch(this.state.apiUrl + '/TicketRest/EditTicket/id/' + this.props.match.params.ticketId + '/userAuthKey/' + this.state.userAuthKey)
                .then((Response) => Response.json())
                .then((responseJson) =>
        {
                responseJson = this.rawjsonparse(responseJson, 1);
                this.setState({
                    ticket:responseJson.ticket,
                    studioname:responseJson.studioname,
                    etaDate:responseJson.ticket.eta,
                    accountManagerId: responseJson.account_manager_id
                }) 
                //alert(this.state.ticket.eta);
                        if (this.state.ticket.eta != '0000-00-00') {
                    let x = Date.parse(this.state.ticket.eta);
                    this.setState({startDate:moment(x)})
                }

        })
    }

    ImagesList() {
        fetch(this.state.apiUrl + '/TicketRest/EditTicket/id/' + this.props.match.params.ticketId + '/userAuthKey/' + this.state.userAuthKey)
                .then((Response) => Response.json())
                .then((responseJson) =>
        {
                responseJson = this.rawjsonparse(responseJson, 1);
                this.setState({
                    imageDet:responseJson.ticket
                }) 
        })
    }

    componentDidMount()
    {
       
        document.title = "Intranet | Edit Ticket";
                if (!localStorage.getItem('userLogin')){
            this.setState({redirect:true});
          }
        this.ticketsList();
        this.getTicketDetails();
          this.ImagesList();
          $(document).ready(function () {
            $('.upload_btn label').click(function(){
                $('.upload_btn .inputfile').click();
            });
                $('.inputfile').each(function()
            {
        var $input = $(this),
                $label = $input.next('label'),
                labelVal = $label.html();
                $input.on('change', function(e)
            {
                var fileName = '';
                        if (this.files && this.files.length > 1)
                        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                        else if (e.target.value)
                        fileName = e.target.value.split('\\').pop();
                        if (fileName)
                        $label.find('span').html(fileName);
                else
                        $label.html(labelVal);
            });
            // Firefox bug fix
            $input
                .on('focus', function(){ $input.addClass('has-focus'); })
                .on('blur', function(){ $input.removeClass('has-focus'); });
        });
    });
    }
       
        showImage(s3url, img)
    {
        if (img != '') {
        var win = window.open(s3url + img, '_blank');
            win.focus()
        }
    }
    tick() {
        this.setState({
          checkBox: !this.state.checkBox
        })
    
        this.state.checkBox ? this.setState({ setdefault: '1' }) : this.setState({ setdefault: '' })
    
      }
        delteimage(s3url, img){
        // alert(img);
        if (window.confirm('Are you sure to delete?')) {
        fetch(this.state.apiUrl + '/TicketRest/deleteTicketImage/id_ticket/' + this.props.match.params.ticketId + '/image/' + img + '/userAuthKey/' + this.state.userAuthKey + '/userid/' + this.state.userId + '/username/' + this.state.userName)
                .then((Response) => Response.json())
                .then((findresponse) =>
       {
           //console.log(findresponse);
          //window.location.href='/editTicket/'+this.props.match.params.ticketId;
          this.ImagesList();
       }) 
       }
     }
     isValidNumber(number) {
		var pattern = /^[0-9]+$/;
		return pattern.test(number);
		}
    
   render(){

    let selectManger = '';
    if(this.state.accountManagerId != null)
    {
          selectManger = (<select  class="form-control" id="account_managerinse" name="account_managerinse" value={this.state.accountManagerId}  onChange={this.onChange.bind(this, 'account_manager')} disabled>
                        <option value='all' > All</option>
                        {
                this.state.account_manager.map((dynamicData, key) =>
                           <option value={dynamicData.id} >{dynamicData.name}</option>
                             )
                         }
                </select>)
    }


        if (this.state.redirect) {
            return (
              <Redirect to={'/login'} />
            )
          } 
         
        return(
            <div>
               <Header brecum_name="Support" brecum_page="Update Ticket"/>
            <div class="right_col">
            <div class="intranet_body">
                <div class="title mob"><HeaderMob page_name="Update Ticket"/></div>
              <div class="top-row-form">
					<div class="form-group">
					  <label for="title">Title<span class="star">*</span></label>
					  <input type="text" name="title"  className="form-control" onChange={this.onChange.bind(this, 'title')} value={this.state.ticket.title}/>
                      <span style={{color: "red"}}>{this.state.errors["title"]}</span>
                    </div>
					<div class="form-group">
					  <label>Descriptions<span class="star">*</span></label>
                      <textarea class="form-control" name="description" id="description" rows="4" cols="50" onChange={this.onChange.bind(this, 'description')} value={this.state.ticket.description}></textarea>
                      <span style={{color: "red"}}>{this.state.errors["description"]}</span>
                    </div>
				</div>
                <div class="form-section add row">
                <div className="form-group col-md-4 col-xs-12">
                <label>#ER</label>
                <input type="text" name="helpdesk_id"  className="form-control" onChange={this.onChange.bind(this, 'helpdesk_id')} value={this.state.ticket.helpdesk_id} />
                <span class="note">Add Er separated by comma ( , )</span>
                </div>
                <div className="form-group col-md-4 col-xs-6">
                <label>Type</label>
               <select  class="form-control" id="type" name="type"  value={this.state.ticket.type} onChange={this.onChange.bind(this, 'type')}>
                        <option value="Bug">Bug</option>Issue
                        <option value="New Feature">New Feature</option>
                        <option value="How To">How To</option>
                        <option value="SetupMigration">Setup/Migration</option>
                </select>
                </div>
                <div className="form-group col-md-4 col-xs-6">
                <label>App</label>
                <select  id="appname" class="form-control" name="appname" onChange={this.onChange.bind(this, 'app')} value={this.state.ticket.app}>
                        {
                this.state.app.map((dynamicData, key) =>
                           <option value={dynamicData.app_id}>{dynamicData.app_name}</option>
                             )
                         }
                </select>
                </div>
                <div className="form-group col-md-4 col-xs-6">
                <label>Priority</label>
                <select class="form-control" name="priorty" id="priorty" value={this.state.ticket.priority}  onChange={this.onChange.bind(this, 'priority')} >
                    <option value="critical">Critical</option>
                    <option value="high">High</option>
                    <option value="medium" selected>Medium</option>
                    <option value="low">Low</option>
                    {/* <option value="all" >All</option> */}
                </select>
                </div>
                <div className="form-group col-md-4 col-xs-6">
                <label>Customer(Studio)</label><br/>
                <div class="form-control no_border">{this.state.studioname}</div>
                </div>
                <div className="form-group col-md-4 col-xs-6 icon-live icon-date">
                <label>ETA</label>
                <DatePicker
                    readOnly={true}
                    selected={this.state.startDate}
                    onChange={this.handleChangeDate}
                    minDate={moment()}
                    placeholderText="Select a date"
                    />
                <i class="fa fa-calendar" aria-hidden="true"></i>
                </div>
                <div className="form-group col-md-4 col-xs-6">
                <label>Status</label>
                <select class="form-control" name="status" id="status" value={this.state.ticket.status} onChange={this.onChange.bind(this, 'status')} >
                    <option value="Open" selected>Open</option>
                        <option value="Resolved">Resolved</option>
                    <option value="Re-opened">Re-opened</option>
                    <option value="Closed">Closed</option>
                </select>
                </div>
                <div className="form-group col-md-4 col-xs-12">
                <label>Owner</label>
                   <select  id="assigned_to" class="form-control" name="assigned_to" value={this.state.ticket.assigned_to} onChange={this.onChange.bind(this, 'assigned_to')} >
                         {
                this.state.owners.map((dynamicData, key) =>
                           <option value={dynamicData.id}>{dynamicData.name}</option>
                             )
                         }
                     </select>
                </div>
                <div className="form-group col-md-4 col-xs-12">
                <label>Escalation Level</label>
                <select class="form-control" id="escalation_level" name="escalation_level" value={this.state.ticket.escalation_level} onChange={this.onChange.bind(this, 'escalation_level')}>
                    <option value="L1" >L1</option>
                    <option value="L2">L2</option>
                    <option value="L3">L3</option>
                    <option value="L4">L4</option>
                    <option value="L5">L5</option> 
                    <option value="L6">L6</option> 
                    <option value="L7">L7</option> 
                    </select>
                </div>
                <div className="form-group col-md-4 col-xs-12">
                <label>Cc</label>
                <textarea class="checkSpace form-control" name="ticket_email_cc"  id="email_cc_feature" onChange={this.onChange.bind(this, 'ticket_email_cc')} value={this.state.ticket.ticket_email_cc}></textarea>
                <span class="note">Add emails with separated by comma ( , )</span>
                </div>
                <div className="form-group col-md-4 col-xs-12">
                <label>Account Manager</label>
                        {selectManger}
                </div>
                <div className="form-group col-md-4 col-xs-12">
                <label>Dev Hour(s)</label>
                <input type="text" name="dev_hours"  className="form-control" onChange={this.onChange.bind(this, 'dev_hours')} value={this.state.ticket.dev_hours}/>
                <span className="error">{this.state.errors["dev_hours"]}</span>
                </div>
                </div>
                <div className="row">
                <div class="radio feature-check">
                        <input class="valid_fld" id="11" type="checkbox" name="project"   onClick={this.tick}
          defaultChecked={this.state.check}/>
                        <label for="11">
                            <span></span>
                            Project
                        </label>
                </div>
                </div>
                <div class="details_des">
                            <span class="color-sky">
                            {
                                this.state.imageDet.attachment ? this.state.imageDet.attachment.split(",").map(place => 
                    <div class="note_wrap" /*onClick={() => this.showImage(this.state.attachment_url, place)}*/> {place} <div className="details_des delete">
                            <span  class="color-red" onClick={() => this.delteimage(this.state.imageDet.attachment_url, place)} >
                                        <i class="fa fa-trash"></i>
                                    </span>
                                </div> 
                                </div>
                            ) : ""
                            }
                            </span>
                    </div>
                {/* <input type="file" id="fileInput" multiple/> */}
                <div class="upload">
                <label>Add Attachment :</label>
					<div class="upload_btn">
						<input type="file" name="file-1[]" id="fileInput" class="inputfile inputfile-1" data-multiple-caption="{count} files selected" multiple/>
						<label for="file-1">
							<i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
							<span>Choose file</span>
							<i class="fa fa-cloud-upload-alt hidden-md" aria-hidden="true"></i>
						</label>
					</div>
                                        <span className="error">{this.state.message}</span>
				</div>
                <div className="update_ticket">
                <button type="submit" name="update_ticket" id="update_ticket" className="btn btn-sky mob-btn" onClick={() => this.updateTicket()}>Update Ticket</button>
              <Link to={`/ticket/viewTicket/id/${this.state.ticket.id}`} name={"max"}><button   className="btn btn-blue hidden-sm">Back</button></Link>
              </div>
                </div>
               </div>
            </div>
        )
    }
}
export default EditTicket;


// WEBPACK FOOTER //
// ./src/components/support/EditTicket.js